import React from 'react';
// import CreateShop from '../CreateShop';
// import ActivateShop from '../ActivateShop';
// import ActivateUser from '../ActivateUser';

import {
  Fade,
  Card,
  Stack,
  Avatar,
  Checkbox,
  Typography,
  CardHeader,
  CardActions,
} from '@mui/material';

import jMoment from 'moment-jalaali';
import ReadyShop from './ReadyShop';
import ReadyCoupon from './ReadyCoupon';

import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import RecommendRoundedIcon from '@mui/icons-material/RecommendRounded';
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';

const statuses = {
  TODO: {
    icon: <PlaylistAddCheckCircleRoundedIcon color="inherit" />,
    title: 'ثبت شده',
    color: 'info.main',
  },
  PENDING: {
    icon: <PendingActionsRoundedIcon color="inherit" />,
    title: 'در حال بررسی',
    color: 'warning.main',
  },
  REJECTED: {
    icon: <ErrorRoundedIcon color="inherit" />,
    title: 'رد شده',
    color: 'error.main',
  },
  CANCELLED: {
    icon: <RemoveCircleRoundedIcon color="inherit" />,
    title: 'لغو شده',
    color: 'error.main',
  },
  DOING: {
    icon: <ChangeCircleRoundedIcon color="inherit" />,
    title: 'در حال انجام',
    color: 'primary.main',
  },
  DONE: {
    icon: <RecommendRoundedIcon color="inherit" />,
    title: 'انجام شده',
    color: 'success.main',
  },
};

const types = {
  READY_COUPON: 'درخواست فعالسازی بن',
};

function getType(type) {
  return types[type] || type;
}

function getStatus(status) {
  return statuses[status] || {};
}

// const types = {
//   SET_ROLE: 'درخواست اختصاص نقش',
//   READY_SHOP: 'درخواست فعالسازی فروشگاه',
//   CREATE_SHOP: 'درخواست ایجاد فروشگاه',
//   CREATE_BOOTH: 'درخواست ایجاد غرفه',
//   CREATE_UNIT: 'درخواست ایجاد سازمان',
//   READY_COUPON: 'درخواست تایید بن',
//   SETTLEMENT: 'درخواست تسویه',
// };

export default function Model({ model, delay, checked, refetch, isAssign, handleSelect }) {
  const { id, title, media, status, type, request_date, details } = model;
  return (
    <>
      <Fade in timeout={delay * 150}>
        <Stack direction="row" alignItems="center">
          {isAssign && <Checkbox size="small" checked={checked} onChange={handleSelect} />}
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              bgcolor: 'action.selected',
              // bgcolor: checked ? 'action.disabledBackground' : 'warning.lighter',
            }}
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <Avatar
                  sx={{
                    bgcolor: 'action.hover',
                    color: getStatus(status)?.color,
                  }}
                >
                  {getStatus(status)?.icon}
                </Avatar>
              }
              title={<Typography variant="subtitle1">{getType(model.type)}</Typography>}
              action={<Typography variant="caption">{jMoment(request_date).format('hh:mm')}</Typography>}
            />
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              <Tasks {...model} refetch={refetch} title={getType(model.type)} />
              {/* {model.type === 'READY_COUPON' && (
                <ReadyCoupon id={model.id} refetch={refetch} title={getType(model.type)} />
              )} */}
            </CardActions>
          </Card>
        </Stack>
      </Fade>
    </>
  );
}

function Tasks({type, id, title, refetch}) {
  switch (type) {
    case 'READY_COUPON':
      return <ReadyCoupon id={id} refetch={refetch} title={title} />
    case 'READY_SHOP':
      return <ReadyShop id={id} refetch={refetch} title={title} />;
    default:
      break;
  }
}
